import DropDownButton from "devextreme-react/drop-down-button";
import { useCallback } from "react";
import "./SortByDropDownButton.scss";

export interface SortItem<T = string> {
	id: T;
	text: string;
}

interface SortByDropDownButtonProps<T extends string = string> {
	items: SortItem<T>[];
	hint: string;
	selectedItemKey: T;
	onSortSelectionChange: (sortItem: SortItem<T>) => void;
}

export default function SortByDropDownButton<T extends string = string>({
	items,
	hint,
	selectedItemKey,
	onSortSelectionChange,
}: SortByDropDownButtonProps<T>) {
	const sortDropdownItemRender = useCallback(
		(itemData: SortItem<T>) => (
			<div className="menu-item d-flex">
				<div className="ms-2">
					{itemData.id === selectedItemKey && (
						<i className="me-2 mdi mdi-check" style={{ fontSize: "12px" }} />
					)}
				</div>
				<span className="menu-text">{itemData.text}</span>
			</div>
		),
		[selectedItemKey],
	);

	const handleSortChange = (itemData: SortItem<T>) => {
		onSortSelectionChange(itemData);
	};

	return (
		<DropDownButton
			key={selectedItemKey}
			stylingMode="text"
			icon="mdi mdi-filter-variant"
			showArrowIcon={false}
			hint={hint}
			items={items}
			displayExpr="text"
			keyExpr="id"
			selectedItemKey={selectedItemKey}
			onItemClick={(e) => handleSortChange(e.itemData)}
			dropDownOptions={{
				width: 250,
				wrapperAttr: { class: "sort-menu-dropdown" },
			}}
			itemRender={sortDropdownItemRender}
		/>
	);
}
